import { be } from "date-fns/locale";
import { useState } from "react";
import { FaXmark } from "react-icons/fa6";

function BenefitDetails({
  conservativePpaMaturity,
  conversativePpaCashWithdrawal,
  moderatePpaCashWithdrawal,
  assertivePpaCashWithdrawal,
  moderatePpaMaturity,
  assertivePpaMaturity,
  cyear1,
  cyear2,
  cyear3,
  cyear4,
  cyear5,
  cyear6,
  myear1,
  myear2,
  myear3,
  myear4,
  myear5,
  myear6,
  ayear1,
  ayear2,
  ayear3,
  ayear4,
  ayear5,
  ayear6,
  close,
}) {
  const benefitTypes = [
    {
      id: 0,
      title: "Conservative(Rs)",
      percentage: "4%",
      ppaMaturity: conservativePpaMaturity,
      ppaCashWithdrawal: conversativePpaCashWithdrawal,
      term: 40,
      sumAssured: "100,000",
      currentAge: 25,
      maturityAge: 65,
      withdrawals: {
        10: {
          amount: cyear1,
          ageAtWithdrawal: 35,
        },
        15: {
          amount: cyear2,
          ageAtWithdrawal: 40,
        },
        20: {
          amount: cyear3,
          ageAtWithdrawal: 45,
        },
        25: {
          amount: cyear4,
          ageAtWithdrawal: 50,
        },
        30: {
          amount: cyear5,
          ageAtWithdrawal: 55,
        },
        35: {
          amount: cyear6,
          ageAtWithdrawal: 60,
        },
        40: {
          amount: "",
          ageAtWithdrawal: 65,
        },
        45: {
          amount: "",
          ageAtWithdrawal: 70,
        },
      },
    },
    {
      id: 1,
      title: "Moderate(Rs)",
      percentage: "5%",
      ppaMaturity: moderatePpaMaturity,
      ppaCashWithdrawal: moderatePpaCashWithdrawal,
      term: 40,
      sumAssured: "100,000",
      currentAge: 25,
      maturityAge: 65,
      withdrawals: {
        10: {
          amount: myear1,
          ageAtWithdrawal: 35,
        },
        15: {
          amount: myear2,
          ageAtWithdrawal: 40,
        },
        20: {
          amount: myear3,
          ageAtWithdrawal: 45,
        },
        25: {
          amount: myear4,
          ageAtWithdrawal: 50,
        },
        30: {
          amount: myear5,
          ageAtWithdrawal: 55,
        },
        35: {
          amount: myear6,
          ageAtWithdrawal: 60,
        },
        40: {
          amount: "",
          ageAtWithdrawal: 65,
        },
        45: {
          amount: "",
          ageAtWithdrawal: 70,
        },
      },
    },
    {
      id: 2,
      title: "Assertive(Rs)",
      percentage: "6%",
      ppaMaturity: assertivePpaMaturity,
      ppaCashWithdrawal: assertivePpaCashWithdrawal,
      term: 40,
      sumAssured: "100,000",
      currentAge: 25,
      maturityAge: 65,
      withdrawals: {
        10: {
          amount: ayear1,
          ageAtWithdrawal: 35,
        },
        15: {
          amount: ayear2,
          ageAtWithdrawal: 40,
        },
        20: {
          amount: ayear3,
          ageAtWithdrawal: 45,
        },
        25: {
          amount: ayear4,
          ageAtWithdrawal: 50,
        },
        30: {
          amount: ayear5,
          ageAtWithdrawal: 55,
        },
        35: {
          amount: ayear6,
          ageAtWithdrawal: 60,
        },
        40: {
          amount: "",
          ageAtWithdrawal: 65,
        },
        45: {
          amount: "",
          ageAtWithdrawal: 70,
        },
      },
    },
  ];

  const [activeBenefit, setActiveBenefit] = useState(0);

  const calculateTotalWithdrawals = (benefit) => {
    if (!benefit?.withdrawals) return 0;

    let total = 0;
    Object.values(benefit.withdrawals).forEach((withdrawal) => {
      if (withdrawal?.amount) {
        const amount = parseFloat(String(withdrawal.amount).replace(/,/g, ""));
        total += isNaN(amount) ? 0 : amount;
      }
    });
    return total;
  };

  // 2. Then define calculateNetMaturity
  const calculateNetMaturity = (benefit) => {
    if (!benefit?.ppaMaturity) return "0";

    const totalMaturity = parseFloat(
      String(benefit.ppaMaturity).replace(/,/g, "")
    );
    const totalWithdrawals = calculateTotalWithdrawals(benefit);

    const result = totalMaturity - totalWithdrawals;
    return isNaN(result) ? "0" : result.toLocaleString();
  };

  return (
    <main className="tw-font-haas tw-py-8 tw-space-y-6">
      <hr />
      <div className="tw-flex tw-items-center tw-justify-between tw-gap-3">
        <h5 className="tw-font-haas tw-uppercase tw-font-semibold">
          Benefit Details
        </h5>

        <FaXmark
          className="tw-bg-red-500 tw-rounded-lg tw-p-2 tw-w-8 tw-h-8 tw-flex tw-items-center tw-text-white"
          onClick={close}
        />
      </div>

      {/* Assumed Investment Return section remains the same */}
      <section>
        <p className="tw-font-haas tw-text-black tw-my-1">
          Assumed Investment Return*
        </p>
        <div className="tw-bg-[#F9F9F9] tw-border tw-border-[#E5E5E5] tw-w-fit tw-h-auto tw-p-4 tw-rounded-xl tw-flex tw-grow tw-flex-wrap tw-items-center tw-gap-y-4 tw-gap-x-8">
          {benefitTypes.map((benefit, i) => (
            <div
              key={benefit.id}
              className={`tw-flex tw-items-center tw-gap-x-4 tw-justify-evenly`}
            >
              <div className="tw-flex tw-flex-col tw-gap-0">
                <p>{benefit.title}</p>
                <h5 className="tw-font-haas tw-font-semibold">
                  {benefit.percentage}
                </h5>
              </div>
              <div
                className={` ${
                  i === benefitTypes?.length - 1 ? "tw-hidden" : "tw-block"
                } tw-bg-black/10 tw-w-[1px] tw-h-[60px]`}
              ></div>
            </div>
          ))}
        </div>
      </section>

      {/* PPA Maturity section remains the same */}
      <section>
        <p className="tw-font-haas tw-text-black tw-my-1">
          Total Personal Private Account (PPA) as at Maturity date
        </p>
        <div className="tw-flex tw-grow tw-flex-wrap tw-gap-2">
          {benefitTypes?.map((benefit) => (
            <div
              key={benefit.id}
              className="tw-bg-[#F5F5F5] tw-border tw-border-[#E5E5E5] tw-rounded-xl tw-p-4 tw-flex tw-flex-col tw-items-start"
            >
              <p>{benefit.title}</p>
              <h5 className="tw-font-haas tw-font-semibold">
                {benefit.ppaMaturity || "N/A"}
              </h5>
            </div>
          ))}
        </div>
      </section>

      {/* Maturity Benefit with Cash Withdrawal Option - Updated section */}

      <hr />

      <section>
        <p className="tw-font-haas tw-text-black tw-my-1">
          Assumed Investment Return*
        </p>
        <div className="tw-bg-[#F9F9F9] tw-border tw-border-[#E5E5E5] tw-w-fit tw-h-auto tw-p-4 tw-rounded-xl tw-flex tw-flex-wrap tw-grow tw-items-center tw-gap-x-8">
          {benefitTypes.map((benefit, i) => (
            <div
              key={benefit.id}
              className={`tw-flex tw-items-center tw-gap-x-4 tw-justify-evenly`}
            >
              <div className="tw-flex tw-flex-col tw-gap-0">
                <p>{benefit.title}</p>
                <h5 className="tw-font-haas tw-font-semibold">
                  {benefit.percentage}
                </h5>
              </div>
              <div
                className={` ${
                  i === benefitTypes?.length - 1 ? "tw-hidden" : "tw-block"
                } tw-bg-black/10 tw-w-[1px] tw-h-[60px]`}
              ></div>
            </div>
          ))}
        </div>
      </section>

      <section className="tw-space-y-2">
        <p className="tw-font-haas tw-text-black tw-my-1">
          Maturity Benefit with Cash Withdrawal Option
        </p>

        <div className="tw-bg-transparent tw-border tw-border-black/10 tw-rounded-xl tw-h-auto tw-w-fit tw-p-1">
          {/* Toggle buttons */}
          <div className="tw-flex tw-items-center tw-justify-start tw-gap-x-1">
            {benefitTypes?.map((benefit) => (
              <button
                key={benefit.id}
                onClick={() => setActiveBenefit(benefit.id)}
                className={`tw-font-haas tw-p-2 tw-rounded-lg tw-min-w-[120px] tw-text-center ${
                  activeBenefit === benefit.id
                    ? "tw-bg-[#F1F4D0] tw-text-[#BEC663] tw-font-medium"
                    : "tw-bg-transparent tw-text-gray-600"
                }`}
              >
                {benefit.title}
              </button>
            ))}
          </div>

          {/* Withdrawal details table */}
        </div>

        <div className="tw-flex tw-grow tw-flex-wrap tw-w-full md:tw-w-fit tw-items-start tw-gap-2">
          {Object.entries(benefitTypes[activeBenefit].withdrawals).map(
            ([year, data]) => (
              <div
                key={year}
                className={` ${
                  !data?.amount ? "tw-hidden" : "tw-block"
                } tw-font-haas tw-bg-[#F9F9F9] tw-border tw-border-[#E5E5E5] tw-p-4 tw-rounded-xl`}
              >
                <span className="tw-text-sm">{year + "th"}</span>

                <h5 className="tw-font-haas tw-font-semibold">{data.amount}</h5>
              </div>
            )
          )}
        </div>
        <div className="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-gap-2">
          Maturity benefit payable (PPA) as at Maturity date with Cash
          Withdrawal Option
          <h5 className="tw-font-bold">
            {calculateNetMaturity(benefitTypes[activeBenefit])}
          </h5>
        </div>
      </section>

      <section>
        <div className="alert alert-info tw-rounded-xl tw-p-4 tw-flex tw-flex-col tw-items-start tw-gpa-y-3">
          <div className="tw-bg-white tw-rounded-lg tw-p-2 tw-border tw-border-black/20">
            <img
              src="/altwarning.svg"
              alt="disclaimer-icon"
              className="tw-w-7 tw-h-7"
            />
          </div>

          <span className="tw-text-[18px] tw-font-semibold mb-2">
            Disclaimer
          </span>
          <div className="">
            The range of assumed investment returns stated above are not
            guaranteed and should be taken as indicative amounts. They do not
            represent a minimum nor a maximum amount and are based on a range of
            assumed rates. The amount payable, on the retirement date, will
            depend on the actual rate of investment return declared and may be
            outside the range shown above.
          </div>
        </div>
      </section>
    </main>
  );
}

export default BenefitDetails;
